import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { BaseSectionEditComponent } from '../base-section-edit/base-section-edit.component';
import { AlertService } from 'src/app/services/alert.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SectionService } from 'src/app/services/section.service';
import { fuseAnimations } from '@mobileia/layout-fuse';
import { GoogleStorageService } from 'src/app/services/google-storage.service';

@Component({
  selector: 'app-section-edit-five',
  templateUrl: './section-edit-five.component.html',
  styleUrls: ['./section-edit-five.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class SectionEditFiveComponent extends BaseSectionEditComponent implements OnInit {

  constructor(
    protected alertService: AlertService,
    protected route: ActivatedRoute,
    protected navigator: Router,
    protected service: SectionService,
    protected googleService: GoogleStorageService
  ) {
    super(alertService, route, navigator, service);
    this.serviceGoogle = googleService;
  }
}
